import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { INote, INoteRes } from '../patients/index.type';

const useFetchNotes = ({ patientId }: { patientId?: string }) => {
  const [fetchedNotes, setFetchedNotes] = React.useState<INote[]>([]);
  const [lastId, setLastId] = React.useState<string | null>(null);
  const [hasMore, setHasMore] = React.useState(true);
  const [sortOrder, setSortOrder] = React.useState<'asc' | 'desc'>('desc');

  const { loading: fetchingNotes, makeApiCall } = useApi({
    url: '',
    method: 'GET',
  });

  const getNotes = async (reset = false, newSortOrder?: 'asc' | 'desc') => {
    if (!patientId) return;
    
    if (reset) {
      setLastId(null);
      setFetchedNotes([]);
      setHasMore(true);
      if (newSortOrder) {
        setSortOrder(newSortOrder);
      }
    }

    if (!hasMore && !reset) return;

    const currentSortOrder = newSortOrder || sortOrder;
    
    const dynamicUrl = `/rtm/note?patientId=${patientId}${!reset && lastId ? `&lastId=${lastId}` : ''}&sort=${currentSortOrder}`;

    const { response, error } = await makeApiCall<undefined, INoteRes>(
      undefined,
      dynamicUrl
    );

    if (response?.status === 'success') {
      const newNotes = response.data || [];
      if (newNotes.length > 0) {
        setLastId(newNotes[newNotes.length - 1]._id);
        setFetchedNotes((prev) => (reset ? newNotes : [...prev, ...newNotes]));
        setHasMore(newNotes.length === 5); 
      } else {
        setHasMore(false);
      }
    }

    if (error || response?.status === 'fail') {
      if (reset) {
        setFetchedNotes([]);
      }
      toast.error('Something went wrong while fetching notes. Please try again later');
    }
  };

  return {
    fetchedNotes,
    getNotes,
    fetchingNotes,
    hasMore,
    sortOrder,
    setSortOrder
  };
};

export default useFetchNotes;